import { useId, useState } from 'react';

type Heap = { heapMb: number; heapMinMb: number };

export function HeapFields({
  value,
  onChange,
  unit = 'MB',
}: {
  value: { heapMb: number; heapMinMb?: number };
  onChange: (heap: Heap) => void;
  unit?: 'MB' | 'GB';
}) {
  const id = useId();
  const minimum = value.heapMinMb ?? value.heapMb;
  const [linked, setLinked] = useState(minimum === value.heapMb);
  const scale = unit === 'GB' ? 1024 : 1;
  return (
    <div className="stack" style={{ gap: 8 }} data-search-id="heap">
      <label className="check">
        <input
          type="checkbox"
          checked={linked}
          onChange={(event) => {
            setLinked(event.target.checked);
            if (event.target.checked) onChange({ heapMb: value.heapMb, heapMinMb: value.heapMb });
          }}
        />
        最小と最大を同じにする（おすすめ）
      </label>
      <div className="small faint">Aikar のフラグは最小と最大が同じ値であることを前提にしています。</div>
      <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))' }}>
        <div className="field">
          <label htmlFor={id + '-min'}>ヒープ（最小）</label>
          <input
            id={id + '-min'}
            className="input"
            type="number"
            min={512 / scale}
            max={value.heapMb / scale}
            step={unit === 'GB' ? 0.5 : 1}
            disabled={linked}
            value={minimum / scale}
            onChange={(event) =>
              onChange({
                heapMb: value.heapMb,
                heapMinMb: Math.min(Math.round(Number(event.target.value) * scale), value.heapMb),
              })
            }
          />
          <span className="small muted">{unit}</span>
        </div>
        <div className="field">
          <label htmlFor={id + '-max'}>ヒープ（最大）</label>
          <input
            id={id + '-max'}
            className="input"
            type="number"
            min={512 / scale}
            step={unit === 'GB' ? 0.5 : 1}
            value={value.heapMb / scale}
            onChange={(event) => {
              const heapMb = Math.round(Number(event.target.value) * scale);
              onChange({ heapMb, heapMinMb: linked ? heapMb : Math.min(minimum, heapMb) });
            }}
          />
          <span className="small muted">{unit}</span>
        </div>
      </div>
    </div>
  );
}
